const properties = [
  { text: 'Contact Property', value: 'user' },
  { text: 'Custom Event', value: 'customEvent' },
  { text: 'Hosted Unsubscribe Click', value: 'hostedUnsubscribeClick' },
  { text: 'Journey Exit', value: 'journeyExit' },
  { text: 'Purchase', value: 'purchase' },
  { section: true, text: 'email' },
  { text: 'Email Bounce', value: 'emailBounce' },
  { text: 'Email Click', value: 'emailClick' },
  { text: 'Email Complaint', value: 'emailComplaint' },
  { text: 'Email Open', value: 'emailOpen' },
  { text: 'Email Send Skip', value: 'emailSendSkip' },
  { text: 'Email Send', value: 'emailSend' },
  { section: true, text: 'In-App' },
  { text: 'In-App Click', value: 'inAppClick' },
  { text: 'In-App Close', value: 'inAppClose' },
  { text: 'In-App Delete', value: 'inAppDelete' },
  { text: 'In-App Delivery', value: 'inAppDelivery' },
  { text: 'In-App Open', value: 'inAppOpen' },
  { text: 'In-App Send Skip', value: 'inAppSendSkip' },
  { text: 'In-App Send', value: 'inAppSend' },
  { section: true, text: 'Inbox' },
  { text: 'Inbox Message Impression', value: 'inboxMessageImpression' },
  { text: 'Inbox Session', value: 'inboxSession' },
  { section: true, text: 'Lists' },
  { text: 'Subscribe', value: 'emailSubscribe' },
  { text: 'Unsubscribe', value: 'emailUnSubscribe' },
  { section: true, text: 'Push' },
  { text: 'Push Bounce', value: 'pushBounce' },
  { text: 'Push Open', value: 'pushOpen' },
  { text: 'Push Send Skip', value: 'pushSendSkip' },
  { text: 'Push Send', value: 'pushSend' },
  { text: 'Push Uninstall', value: 'pushUninstall' },
  { section: true, text: 'SMS' },
  { text: 'SMS Bounce', value: 'smsBounce' },
  { text: 'SMS Reply', value: 'smsReceived' }, // SMS Reply is smsReceived in old ui
  { text: 'SMS Send Skip', value: 'smsSendSkip' },
  { text: 'SMS Click', value: 'smsClick' },
  { text: 'SMS Send', value: 'smsSend' },
  { section: true, text: 'Web Push' },
  { text: 'Web Push Click', value: 'webPushClick' },
  { text: 'Web Push Send Skip', value: 'webPushSendSkip' },
  { text: 'Web Push Send', value: 'webPushSend' },
  { section: true, text: 'WhatsApp' },
  { text: 'WhatsApp Bounce', value: 'whatsAppBounce' },
  { text: 'WhatsApp Click', value: 'whatsAppClick' },
  { text: 'WhatsApp Reply', value: 'whatsAppReceived' },
  { text: 'WhatsApp Seen', value: 'whatsAppSeen' },
  { text: 'WhatsApp Send', value: 'whatsAppSend' },
  { text: 'WhatsApp Send Skip', value: 'whatsAppSendSkip' },
];

export default properties;
